
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant- General
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>Master’s Degree in relevant subject or technical qualifications like BE /B.Tech, MBA or equivalent.</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        		
           <h3>Essential:</h3>

        <p> <span class="step_no">1</span>Objective thinker and good documentation Skills.</p>
        <p> <span class="step_no">2</span>Strong analytical and  interpersonal skills in English and Hindi language. </p>
        <p> <span class="step_no">3</span>Minimum of 1-2 years of work experience relevant to the job description. The broad work experience related to the functional areas assigned .</p>
			
			
      </div>
    </div>
  </div>
  <!-- feature box close -->


<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        		
       
			
			<h3>Desirable:</h3>

        <p> <span class="step_no">1</span>Preference will be given to persons with good work experience in the relevant field supported by published work/policy papers/monitoring of projects & schemes etc.</p>
        <p> <span class="step_no">2</span>Candidate should have good knowledge on working on computer (MS-Office and other applications)</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 45,000/- to Rs. 50,000/- per month consolidated pay from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 9th May 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  

    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Scope Of Work:</h3>
        
			
<p><span class="step_no">1</span>Coordinate with persons working in NIMi Delhi Office</p>
<p><span class="step_no">2</span>Liaising with state officials, other stakeholders pertaining to  development of Instructional material, Question Bank , Translation   and other NIMI activities</p>
<p><span class="step_no">3</span>Promote sale of NIMI Instructional Media Packages (Books) in Northern Region </p>
<p><span class="step_no">4</span>Monitor day to day sales at NIMI Office at NSTI(W), Noida </p>
<p><span class="step_no">5</span>Document work on a daily basis. </p>
<p><span class="step_no">6</span>Attend meeting of DGT, Ministry of Skill Development and Entrepreneurship (MSDE) and other bodies pertaining to NIMI activities</p>
<p><span class="step_no">7</span>Record minutes of meeting for the above</p>
<p><span class="step_no">8</span>To communicate feedback and suggestions and to prepare report/data  accordingly </p>
<p><span class="step_no">9</span>Able to work independently  in a self guided mode and solve  problems </p>
<p><span class="step_no">10</span>Preparing, updating  and maintaining  records/data pertaining  to NIMI  activities in Delhi Office</p>
<p><span class="step_no">11</span>Sending mails/informations etc. to state directorates and other stakeholders. </p>
<p><span class="step_no">12</span>Any other works assigned by superior/competent authority</p>

    
    
          </div>
        </div>
      </div>
      <!-- feature box close -->

          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p><span class="step_no">1</span>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year.</p>

            <p><span class="step_no">2</span> The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of  NIMI shall be final in this regard. </p>

            <p><span class="step_no">3</span> The decision of  NIMI shall be final in this regard. </p>

    
          </div>
        </div>
      </div>
      <!-- feature box close -->


    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p><span class="step_no">1</span>NIMI Office at NSTI(W) Noida OR DGT/Ministry , New Delhi </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee. </p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority.</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>



      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card </p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates </p>



      </div>
    </div>
  </div>
  <!-- feature box close -->


<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
